<thumbnail-selector 
	*ngIf="asset && creative.mediatype === 'video'"
	[asset]="asset"
	(onChange)="thumbnailsChanged($event)"
	[thumbnails]="creative.thumbnails"
	[isCreative]="true"
	[assetTitle]="creative.title"
	[entity]="creative"
></thumbnail-selector>
